import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconLastPageStyle0 = gravityIconIndividualCss;

const GravityIconLastPage = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '92ec7131c5c2863c34a30e0a2fcd4ecbc69292ff', color: this.color, size: this.size }, h("svg", { key: '4d07f93f9d80b02bbc8e3a25c2f9aa9340f2b6c8', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'c3c329f499cc791c2a0e9d0487f2d117165fb225', d: "M16.995 4.5a.5.5 0 0 0-.5-.5H16a.5.5 0 0 0-.5.5l-.005 13a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-13ZM6.386 17.836l6.455-6.443a.565.565 0 0 0 0-.786L6.386 4.164a.554.554 0 0 0-.786 0l-.387.387a.565.565 0 0 0 0 .786l5.668 5.658-5.668 5.668a.565.565 0 0 0 0 .786l.387.387a.553.553 0 0 0 .786 0Z", fill: "currentColor" }))));
    }
};
GravityIconLastPage.style = GravityIconLastPageStyle0;

export { GravityIconLastPage as gravity_icon_last_page };

//# sourceMappingURL=gravity-icon-last-page.entry.js.map